import { Component, OnInit, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
@Component({
  selector: 'app-grants-registrations-compliance',
  templateUrl: './grants-registrations-compliance.component.html',
  styleUrls: ['./grants-registrations-compliance.component.scss']
})
export class GrantsRegistrationsComplianceComponent implements OnInit {

  constructor(
  ) { }

  ngOnInit() {
  }

}
